let $hyoo_sync_revision = "3406820"